export const colors = ['#32c7c7', '#fbbac4', '#e8d1b4'];

export default {
  colors
}



// WEBPACK FOOTER //
// ./src/styles/theme.js